var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFavEmpty = function SvgFavEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fav-empty_svg__icon-outline",
    clipRule: "evenodd",
    d: "M13.984 4.945C18.283.07 22.202-.287 25.74 3.875c3.538 4.162-.38 10.137-11.757 17.925C2.764 14.242-1.184 8.267 2.138 3.875c3.53-3.908 7.478-3.55 11.846 1.07z",
    stroke: "#fff",
    strokeWidth: 2
  })));
};
export default SvgFavEmpty;